import { css } from "@emotion/css";
import { Chip, Tooltip } from "@octopusdeploy/design-system-components";
import { space } from "@octopusdeploy/design-system-tokens";
import { isGitCommit, isGitTag, toGitCommitShort, toGitRefShort } from "@octopusdeploy/octopus-server-client";
import type { GitReference } from "@octopusdeploy/octopus-server-client";
import React from "react";
import { ChipLegacyIconWrapper } from "~/components/Chips/ChipIconWrapper";
import { GitBranchIcon, GitCommitIcon, GitTagIcon } from "~/primitiveComponents/dataDisplay/Icon";
interface GitRefChipProps {
    vcsRef: GitReference;
    showCommit?: boolean;
    variant?: "default" | "outlined";
    className?: string;
    maxGitRefLength?: number;
}
export const GitRefChip = ({ vcsRef, showCommit = true, variant, className, maxGitRefLength }: GitRefChipProps) => {
    // Material Chips don't really expect an icon in the label, so we need to bend the styling to our will
    const iconInLabelStyles = {
        verticalAlign: "sub",
        marginRight: space[4],
        marginLeft: space[8],
    };
    const GitRefIcon = isGitCommit(vcsRef.GitRef) ? GitCommitIcon : isGitTag(vcsRef.GitRef) ? GitTagIcon : GitBranchIcon;
    const gitRefText = vcsRef.GitRef && (<Tooltip key="ref" content={vcsRef.GitRef} display="flex">
            <span className={styles.chipLabel} style={{ maxWidth: `${maxGitRefLength}ch` }}>
                {toGitRefShort(vcsRef.GitRef)}
            </span>
        </Tooltip>);
    const innerCommitChip = isGitCommit(vcsRef.GitRef)
        ? null
        : vcsRef.GitCommit && (<Tooltip content={vcsRef.GitCommit} key="commit" display="flex">
                  <GitCommitIcon key="icon" className="MuiChip-icon MuiChip-iconSmall" style={iconInLabelStyles}/>
                  <span className={styles.chipLabel} key="value">
                      {toGitCommitShort(vcsRef.GitCommit)}
                  </span>
              </Tooltip>);
    const label = showCommit ? (<div className={styles.labelContainer}>
            {gitRefText} {innerCommitChip}
        </div>) : (gitRefText);
    return (vcsRef && vcsRef.GitRef && <Chip icon={<ChipLegacyIconWrapper iconComponent={GitRefIcon}/>} label={label} variant={variant} className={className}></Chip>) || null;
};
// Replicating the `Chip` component styles here
const styles = {
    labelContainer: css({ display: "flex" }),
    chipLabel: css({
        fontSize: "0.75rem",
        fontWeight: "normal",
        textOverflow: "ellipsis",
        whiteSpace: "nowrap",
        overflow: "hidden",
    }),
};
